const WIDTH = {
  static: 70,
  attr: 200,
  allowedparams: 200,
  checkbox: 100,
  children: 80,
  defaultparams: 200,
  field: 200,
  fieldsArray: 200,
  image: 80,
  params: 200
}
const HEIGHT = {
  short: 46,
  medium: 76,
  tall: 106,
  extraTall: 136

}
const MIN_WIDTH = 70
const DEFAULT_WIDTH = 200

export default {
  namespaced: true,
  state: {
    sidebar: false,
    cursor: {
      col: -1,
      row: -1
    },
    tables: {},
    tablesStates: {},
    errorPart: {},
    modalCloser: null
  },
  getters: {
    isTablesStates: (state) => (key) => {
      if (state.tablesStates[key]) {
        return true
      }
      return false
    },
    tableStyle: (state, getters, rootState) => key => {
      if (state.tables[key]) {
        return {
          '--cols': state.tables[key].cols.join('px ') + 'px',
          '--rows': `repeat(${rootState.parts.data[key].totalRows}, ${state.tables[key].rows}px)`
        }
      }
      return false
    },
    rowsMode: state => key => {
      return state.tables[key]?.rowsMode || null
    },
    getStatuses: state => payload => {
      const statuses = state.tablesStates[payload.db]?.[payload.key]?.[payload.index]
      let statusesString = ''
      if (statuses && Object.keys(statuses).length > 0) {
        for (const k in statuses) {
          if (statuses[k]) statusesString += (k + ' ')
        }
      }
      return statusesString
    }
  },
  mutations: {
    closeModal (state, payload) {
      state.modalCloser = payload
    },
    setErrorPart (state, payload) {
      state.errorPart = payload
    },
    setSidebarState (state, payload) {
      state.sidebar = payload
    },
    addTableStatesProperties (state, payload) {
      state.tablesStates[payload.subtable] = {
        colsStates: [],
        rowsStates: []
      }
    },
    resizeRows (state, payload) {
      state.tables[payload.subtable].rows = HEIGHT[payload.height]
      state.tables[payload.subtable].rowsMode = payload.height
    },
    setCellStatus (state, payload) {
      let value = { ...payload.status }
      const statuses = state.tablesStates[payload.db][payload.key][payload.index]
      if (statuses && Object.keys(statuses).length > 0) value = { ...statuses, ...payload.status }

      state.tablesStates[payload.db][payload.key][payload.index] = value
    },
    setCursorPosition (state, payload) {
      state.cursor.col = payload.col
      state.cursor.row = payload.row
    },
    setTable (state, payload) {
      state.tables = { ...payload.settings }
    }
  },
  actions: {
    resetTableStyle ({ rootState, state, dispatch }, subtable) {
      delete state.tables[subtable]
      dispatch('addTableProperties', {
        subtable: subtable,
        ...rootState.parts.data[subtable]
      })
      dispatch('putSettings')
    },
    resizeColumn ({ state, rootState }, payload) {
      const column = state.tables[payload.subtable].cols[payload.index]
      let minWidth = MIN_WIDTH
      const colIndex = rootState.parts.data[payload.subtable].columns[payload.index].colIndex
      if (colIndex === 0) {
        minWidth = 120
      }
      if ((column + payload.delta) >= minWidth) {
        state.tables[payload.subtable].cols[payload.index] += payload.delta
      }
    },
    addTableProperties ({ state, getters, dispatch }, payload) {
      const actionsColWidth = 120
      if (!getters.tableStyle(payload.subtable)) {
        const table = state.tables[payload.subtable] = {
          rowsMode: 'medium',
          rows: HEIGHT.medium,
          cols: []
        }
        payload.columns?.forEach(c => {
          if (c.colIndex === 0) {
            table.cols.push(actionsColWidth)
          } else table.cols.push(WIDTH[c.category] || DEFAULT_WIDTH)
        })
      } else if (payload.totalCols !== state.tables[payload.subtable].cols.length) {
        const tableCols = state.tables[payload.subtable].cols
        if (tableCols.length > payload.totalCols) {
          state.tables[payload.subtable].cols = tableCols.slice(0, payload.totalCols)
        } else {
          const needCols = payload.totalCols - tableCols.length
          for (let step = 0; step < needCols; step++) {
            state.tables[payload.subtable].cols.push(DEFAULT_WIDTH)
          }
        }
        dispatch('putSettings')
      } else if (state.tables[payload.subtable].cols[0] < actionsColWidth) {
        state.tables[payload.subtable].cols[0] = actionsColWidth
        dispatch('putSettings')
      }
    },
    resizeRows ({ commit, dispatch }, payload) {
      commit('resizeRows', payload)
      dispatch('putSettings')
    },
    async getSettings ({ rootState, commit, dispatch }) {
      const settings = await fetch(`${rootState.api.host}${rootState.api.endpoint.userCurrent}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          Authorization: 'Bearer ' + rootState.user.accesToken
        }
      })
      if (settings.ok) {
        const response = await settings.json()
        if (response) {
          rootState.user.role = response.user.role
          commit('setTable', { settings: response.user.settings })
        }
        return true
      } else {
        if (settings.status === 401) {
          dispatch('logout', null, { root: true })
        }
      }
    },
    putSettings ({ rootState, state }) {
      fetch(`${rootState.api.host}${rootState.api.endpoint.userSettings}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          Authorization: 'Bearer ' + rootState.user.accesToken
        },
        body: JSON.stringify({
          settings: state.tables
        })
      })
    }
  }
}
